angular.module('LeasePilot').directive('renameFormVersionsModal', [
  '$http',
  '$mdDialog',
  function($http, $mdDialog) {
    return {
      restrict: 'E',
      templateUrl: 'rename_form_versions_modal.html',
      link: function($scope, element, attrs) {
        $scope.formId = attrs.formId;
        $scope.flavor = attrs.flavor;
        $scope.currentVersion = attrs.version;
        $scope.currentBuildingVersion = attrs.buildingVersion;

        $scope.newVersion = attrs.version;
        $scope.newBuildingVersion = attrs.buildingVersion;

        $scope.errors = [];
        $scope.warnings = [];
        $scope.isProcessing = false;

        function padded(value) {
          const number = parseInt(value, 10);
          return isNaN(number) ? '' : _.padStart(number.toString(), 5, '0');
        }

        $scope.hasChanges = function() {
          return (
            padded($scope.newVersion) !== $scope.currentVersion ||
            padded($scope.newBuildingVersion) !== $scope.currentBuildingVersion
          );
        };

        // Warnings are tied to the numbers that produced them, so editing the
        // numbers asks the server again instead of confirming stale warnings.
        $scope.inputChanged = function() {
          $scope.errors = [];
          $scope.warnings = [];
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.rename = function() {
          if (!$scope.hasChanges() || $scope.isProcessing) return;

          $scope.isProcessing = true;
          $scope.errors = [];

          $http
            .patch(`/api/forms/${$scope.formId}/rename_versions`, {
              version: $scope.newVersion,
              building_version: $scope.newBuildingVersion,
              acknowledge_warnings: $scope.warnings.length > 0,
            })
            .then(response => {
              if (response.data && response.data.requires_confirmation) {
                $scope.warnings = response.data.warnings;
                $scope.isProcessing = false;
                return;
              }

              window.location.reload();
            })
            .catch(error => {
              $scope.errors = (error.data && error.data.errors) || [
                'Failed to rename the versions',
              ];
              $scope.isProcessing = false;
            });
        };
      },
    };
  },
]);
